import { render, staticRenderFns } from "./topPoints.vue?vue&type=template&id=7d868f31&scoped=true"
import script from "./topPoints.vue?vue&type=script&lang=js"
export * from "./topPoints.vue?vue&type=script&lang=js"
import style0 from "./topPoints.vue?vue&type=style&index=0&id=7d868f31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d868f31",
  null
  
)

export default component.exports